const state = {
  coupons: [],
  processing: false,
};

export default state;
